import React from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import CustomPagination from "../../../components/Common/CustomPagination";
import Filter from "../../../components/Common/Filter";
import { Link, useLocation } from "react-router-dom";
import dataHandler from "../../../hooks/dataHandler";
import { PRICINGSTATUSUPDATE, ROOMPRICINGLIST } from "../../../services/ApiCalls";
import CountryFilter from "../../../components/Common/CountryFilter";
import {
  availabilityFilter,
} from "../../../utilities/const";
import { useTranslation } from "react-i18next";

const PricingSection = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: ROOMPRICINGLIST,
  });

  const handleAvailablity = async (e, id) => {
    console.log("handleAvailablity", e.target.checked, id);
    const body = {
      isAvailable: e.target.checked,
      id
    };
    deleteHandler(() => PRICINGSTATUSUPDATE(body))


  }

  const column = [
    {
      head: t("pricing.columns.srNo"),
      accessor: "#",
      component: (item, key) => <>{key < 9 ? `${key + 1}` : key + 1}</>,
    },
    {
      head: t("pricing.columns.hotelName"),
      accessor: "hotelId",
      component: (item) => <>{item.hotelId?.hotelName || "-"}</>,
    },
    {
      head: t("pricing.columns.roomType"),
      accessor: "roomType",
      component: (item) => <>{item.roomType?.roomType?.name || "-"}</>,
    },
    {
      head: t("pricing.columns.base_price"),
      accessor: "basePrice",
      component: (item) => <>{item.basePrice || "-"}</>,
    },
    {
      head: t("pricing.columns.final_price"),
      accessor: "finalPrice",
      component: (item) => <>{item.finalPrice || "-"}</>,
    },

    {
      head: t("pricing.columns.available"),
      accessor: "status",
      component: (item) => (
        <div>
          <Form.Check
            type="switch"
            id="status-switch"
            defaultChecked={item.isAvailable}
            onChange={(e) => handleAvailablity(e, item?._id)}
            style={{ transform: "scale(1.4)", cursor: "pointer", marginLeft: 20 }}
            className="form-switch-success"
          />
        </div>

      ),
    },
    {
      head: t("pricing.columns.action"),
      accessor: "action",
      component: (item) => (
        <TableActions
          editUrl={`/pricing/edit/${item._id}?page=${body.page}`}
          viewLink={`/pricing/detail/${item._id}?.page=${body.page}`}

        />
      ),
    },
  ];

  return (
    <>
      <section className="room-management position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("pricing.title")}
                </h4>

                <div className="d-flex align-items-center gap-2">
                  <label
                    htmlFor="countryFilter"
                    className="form-label m-0 fw-semibold text-muted"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {t("pricing.filter")}
                  </label>
                  <CountryFilter
                    id="countryFilter"
                    body={body}
                    setBody={setBody}
                  />
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    setBody={setBody}
                    statusFilterOptionArr={availabilityFilter}
                  />
                </div>
                <div className="right d-flex gap-3">
                  <Link
                    to="/pricing/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    {t("pricing.addPricing")}
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PricingSection;
